import React from 'react';
import { AlertTriangle, MapPin, Phone } from 'lucide-react';

/**
 * Badge showing camp needs validation
 */
export const ValidationBadge = ({ camp }) => {
  if (!camp.needs_validation) return null;
  
  const getBadgeContent = () => {
    if (camp.validation_status === 'needs_coordinates') {
      return {
        icon: MapPin,
        text: 'Location unverified',
        color: 'orange'
      };
    }
    if (camp.validation_status === 'needs_contact') {
      return {
        icon: Phone,
        text: 'Contact missing',
        color: 'yellow'
      };
    }
    return {
      icon: AlertTriangle,
      text: 'Needs verification',
      color: 'gray'
    };
  };
  
  const { icon: Icon, text, color } = getBadgeContent();
  
  const colorClasses = {
    orange: 'bg-orange-100 text-orange-800 border-orange-200',
    yellow: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    gray: 'bg-gray-100 text-gray-800 border-gray-200'
  };
  
  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs border ${colorClasses[color]}`}>
      <Icon className="w-3 h-3" />
      {text}
    </div>
  );
};

/**
 * Warning in camp card for incomplete data
 */
export const CampValidationWarning = ({ camp }) => {
  if (!camp.needs_validation) return null;
  
  return (
    <div className="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded text-xs text-yellow-800">
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-medium">Information may be incomplete</p>
          <p className="text-yellow-700 mt-0.5">
            {camp.validation_reason === 'missing_coordinates' && 
              'Location data is not available. Contact the camp for directions.'}
            {camp.validation_reason?.includes('contact') && 
              'Contact information is limited. Please verify details with the camp.'}
            {!camp.validation_reason && 
              'Some details need verification. Please confirm with the camp directly.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default { ValidationBadge, CampValidationWarning };

